<template>
  <modal-form :class="$style.dialog" @cancel="$formCancelHandler" @submit="$formSubmitHandler">
    <span slot="header">Change Your Password</span>

    <div slot="body" class="vModalDefaultBody">
      <rb-input for-id="newPassword" :error="$showError('newPassword')">
        <span slot="label">Enter New Password</span>
        <input
          id="newPassword"
          v-model="data.password"
          v-validate="{required: true, max: 200, min: 8, has_lowercase: true, has_uppercase: true, has_number: true, no_whitespace: true}"
          type="password"
          name="newPassword"
          class="rbInput"
          data-vv-as="Password"
        >
      </rb-input>
      <rb-input for-id="confirmPassword" :error="$showError('confirmPassword')">
        <span slot="label">Confirm New Password</span>
        <input
          id="confirmPassword"
          v-model="data.confirmPassword"
          v-validate="{ required: true, value: data.password }"
          type="password"
          name="confirmPassword"
          class="rbInput"
          data-vv-as="Confirm Password"
        >
      </rb-input>
    </div>
  </modal-form>
</template>

<script>
  import ModalForm from 'vRoot/_core/RbModalForm.vue'
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbFormMixin from 'vRoot/_mixins/RbFormMixin.vue'
  import RbInput from 'vRoot/_core/RbInput.vue'

  export default {
    name: 'RbvUserProfileEditPersonalInfoDialog',
    components: { RbInput, ModalForm },
    mixins: [ RbFormMixin, DialogMixin ],
    data() {
      return {
        data: {
          password: '',
          confirmPassword: ''
        }
      }
    },
    methods: {
      onSubmit () { return { form: { password: this.data.password} } }
    }
  }
</script>

<style lang="stylus" module="">
  .dialog {
    min-width 400px
  }
</style>

